import React from 'react';
import TableC from '../../../basicElement/TableC';
import moment from 'moment';

const isMain = (text) => text != null ? `${text ? '主' : '次'}带教老师` : '';

export default function Feedback(props) {
    const { loading, data, date } = props;

    const prevQuarter = date ? moment(date).subtract(3, 'M').format('YYYY-MM') : '';
    const getColumns = () => ([{
        title: 'CRC姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width: 100,
    }, {
        title: 'CRC工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        width: 100,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 140,
    }, {
        title: prevQuarter,
        children: [{
            title: 'CRC季度评分',
            dataIndex: 'firstScore',
            key: 'firstScore',
            width: 60,
        }, {
            title: '带教身份',
            dataIndex: 'firstIsMain',
            key: 'firstIsMain',
            width: 80,
            render: isMain,
        }]
    }, {
        title: date,
        children: [{
            title: 'CRC季度评分',
            dataIndex: 'secondScore',
            key: 'secondScore',
            width: 60,
        }, {
            title: '带教身份',
            dataIndex: 'secondIsMain',
            key: 'secondIsMain',
            width: 80,
            render: isMain,
        }]
    }]);

    const getDataSource = () => {
        return data || [];
    };

    return (
        <div>
            <div style={{ lineHeight: '48px' }}>5.PM季度反馈得分明细</div>
            <TableC
                scrollY={300}
                loading={loading}
                columns={getColumns()}
                data={getDataSource()}
                className="feedback"
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/tables/Feedback.js